var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-common",style:([
  !_vm.module.base.m ? { 'margin-top': '0' } : {},
  {
    padding:
      '0px ' + _vm.module.base.margins + 'px 0px ' + _vm.module.base.margins + 'px'
  },
  { 'border-radius': _vm.module.base.round + 'px' }
])},[_c('div',{staticClass:"menu_class",style:([{ 'border-radius': _vm.module.base.round + 'px' }])},[_c('van-grid',{staticStyle:{"background-color":"#FFFFFF"},attrs:{"column-num":_vm.module.max,"border":false}},_vm._l((_vm.module.list),function(item,index){return _c('van-grid-item',{key:index,attrs:{"icon":"photo-o","text":item.name}},[_c('van-image',{staticStyle:{"width":"45px","height":"45px","border-radius":"5px"},attrs:{"round":"","src":item.imageUrl}}),_c('div',{staticStyle:{"font-size":"12px","color":"#303133","text-align":"center","margin-top":"10px"}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }